import * as React from "react";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  CssBaseline,
  Divider,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  Toolbar,
  Typography,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  InputAdornment,
  Checkbox,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Search as SearchIcon, Visibility as VisibilityIcon, AssignmentInd as AssignmentIndIcon, PriceCheck as PriceCheckIcon } from "@mui/icons-material";
import {
  ArrowBack as ArrowBackIcon,
  Edit as EditIcon,
  PersonAdd as PersonAddIcon,
  Download as DownloadIcon,
  MoreVert as MoreVertIcon,
  NotificationsNone as NotificationsIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";


export default function Loans({ loans = [] }) {
  const [query, setQuery] = React.useState("");
  const navigate = useNavigate();
  const [status, setStatus] = React.useState("all");
  const [product, setProduct] = React.useState("all");
  const [date, setDate] = React.useState("");
  const [branch, setBranch] = React.useState("all");
  const [selection, setSelection] = React.useState([]);

  // Debug logging
  React.useEffect(() => {
    if (loans && loans.length > 0) {
      console.log('First loan sample:', loans[0]);
    }
  
  }, [loans]);
  const rows = (loans || []).map(loan => ({
    id: loan.id || '',
    loan_id: loan.loan_id || '',
    solicitud_id: loan.solicitud_id || '',
    customer: loan.cliente_nombre || 'Sin nombre',
    product: loan.producto_financiero || 'Sin producto',
    capitalPendiente: loan.capitalPendiente || 10,
    interesPendiente: loan.interesPendiente || 0,
    status: loan.estado || "activo",
    sucursal: loan.sucursal_nombre || "N/A"
  }));

  
  const columns = [
    { field: "loan_id", headerName: "ID Préstamo", minWidth: 150, flex: 1 },
    { field: "customer", headerName: "Cliente", minWidth: 160, flex: 1 },
    { field: "product", headerName: "Producto", minWidth: 140 },
    { field: "capitalPendiente", headerName: "Capital Pend.", minWidth: 140, 
        valueFormatter: (params) => {
          const value = Number(params) || 0;
          return `$${value.toLocaleString()}`;
        } },
    { field: "interesPendiente", headerName: "Interes Pend.", minWidth: 140, 
        valueFormatter: (params) => {
          const value = Number(params) || 0;
          return `$${value.toLocaleString()}`;
        } },
    { field: "status", headerName: "Estado", minWidth: 130, renderCell: (p) => {
        if (!p || p.value === undefined || p.value === null) return <Chip label="N/A" color="default" variant="outlined" size="small"/>;
        const color = p.value === 'activo' ? 'success' : p.value === 'cancelado' ? 'error' : 'warning';
        const label = p.value === 'activo' ? 'Activo' : p.value === 'cancelado' ? 'Cancelado' : p.value;
        return <Chip label={label} color={color} variant={color === 'error' ? 'outlined' : 'soft'} size="small"/>;
      }
    },
    { field: "actions", headerName: "Acciones", sortable: false, filterable: false, minWidth: 140, renderCell: (p) => (
      <Stack direction="row" spacing={1}>
        
        <IconButton size="small" color="inherit" onClick={()=>{navigate(`/gestion_comercial/prestamos/detalle/${p.row.solicitud_id}`)}}><VisibilityIcon fontSize="small" /></IconButton>
        {/*<IconButton size="small" color="inherit"><AssignmentIndIcon fontSize="small"/></IconButton>
        <IconButton size="small" color="inherit"><PriceCheckIcon fontSize="small"/></IconButton> */}  
      </Stack>
    ) },
  ];

  const filtered = rows.filter(r =>
    r.loan_id.toLowerCase().includes(query.toLowerCase()) ||
    r.customer.toLowerCase().includes(query.toLowerCase())
  ).filter(r => (status === 'all' ? true : r.status === status))
   .filter(r => (product === 'all' ? true : r.product === product))
   .filter(r => (branch === 'all' ? true : r.sucursal === branch));

  return (
    <Stack spacing={2}>
      <Card variant="outlined">
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item size={5}>
              <TextField 
                fullWidth 
                placeholder="Buscar por cliente o ID de préstamo..." 
                value={query} 
                onChange={(e)=>setQuery(e.target.value)} 
                InputProps={{ 
                  startAdornment: <InputAdornment position="start"><SearchIcon/></InputAdornment> 
                }} 
              />
            </Grid>
            <Grid item size={5}>
              <Grid container spacing={2}>
                <Grid item size={3}>
                  <FormControl size="small" fullWidth>
                    <InputLabel>Estado</InputLabel>
                    <Select label="Estado" value={status} onChange={(e)=>setStatus(e.target.value)} sx={{backgroundColor:"white"}}>
                      <MenuItem value="all">Todos</MenuItem>
                      <MenuItem value="activo">Activo</MenuItem>
                      <MenuItem value="cancelado">Cancelado</MenuItem>
                      <MenuItem value="vencido">Vencido</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item size={3}>
                  <FormControl size="small" fullWidth>
                    <InputLabel>Producto</InputLabel>
                    <Select label="Producto" value={product} onChange={(e)=>setProduct(e.target.value)} sx={{backgroundColor:"white"}}>
                      <MenuItem value="all">Todos</MenuItem>
                      <MenuItem value="Préstamo Auto">Préstamo Auto</MenuItem>
                      <MenuItem value="Préstamo Personal">Préstamo Personal</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item size={3}>
                  <TextField 
                    size="small" 
                    type="date" 
                    label="Fecha" 
                    fullWidth
                    InputLabelProps={{ shrink: true }} 
                    value={date} 
                    onChange={(e)=>setDate(e.target.value)} 
                  />
                </Grid>
                <Grid item size={3}>
                  <FormControl size="small" fullWidth>
                    <InputLabel>Sucursal</InputLabel>
                    <Select label="Sucursal" value={branch} onChange={(e)=>setBranch(e.target.value)} sx={{backgroundColor:"white"}}>
                      <MenuItem value="all">Todas</MenuItem>
                      <MenuItem value="Sucursal Principal">Sucursal Principal</MenuItem>
                      <MenuItem value="Sucursal Norte">Sucursal Norte</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
            <Grid item size={2}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button variant="contained" color="primarybutton" sx={{fontWeight:"bold",minWidth:120}}>Filtrar</Button>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card variant="outlined">
        {selection.length > 0 && (
          <Box sx={{ borderBottom: 1, borderColor: 'divider', p: 1.5 }}>
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography variant="body2" color="text.secondary">{selection.length} préstamos seleccionados</Typography>
              <Divider orientation="vertical" flexItem />
              <Button startIcon={<DownloadIcon/>} variant="text">Exportar CSV</Button>
              <Button startIcon={<DownloadIcon/>} variant="text">Exportar XLSX</Button>
              <Button startIcon={<PersonAddIcon/>} variant="text">Reasignar</Button>
              <Button startIcon={<span className='material-symbols-outlined'>send</span>} variant="text">Enviar Recordatorio</Button>
            </Stack>
          </Box>
        )}
        <Box sx={{ height: 520 }}>
          <DataGrid
            rows={filtered}
            columns={columns}
            getRowId={(r) => r.id}
            disableRowSelectionOnClick
            onRowSelectionModelChange={(m)=>setSelection(m)}
            pageSizeOptions={[10, 25, 50]}
            initialState={{ pagination: { paginationModel: { pageSize: 10, page: 0 } } }}
            sx={{
              '& .dg-danger': { color: 'red', fontWeight: 600 },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: 'primary.main',
                color: 'white',
                fontWeight: 'bold'
              },
              '& .MuiDataGrid-columnHeader': {
                backgroundColor: 'primary.main',
                color: 'white'
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                color: 'white',
                fontWeight: 'bold'
              }
            }}
          />
        </Box>
      </Card>
    </Stack>
  );
}

